import { get } from 'lodash';
import { IOptionMap, IPremium, ITraveller } from '../../../../../data/api/models';
import { FormattedNumber } from 'react-intl';
import { useEffect, useState } from 'react';
import React = require('react');
import Loading from '../../../../../components/Loading';
import { FaInfoCircle } from 'react-icons/fa';

interface IPriceDisplay {
  leadTraveller?: ITraveller,
  tripType: string,
  title: string,
  options?: IOptionMap,
  premium?: IPremium,
  region?: string,
  destinationsValue?: string[];
  showInfo?: boolean;
  infoText?: string;
  quoteReference?: string;
  schemeId?: string;
}

export const PriceDisplay = ({
                               leadTraveller,
                               tripType,
                               title,
                               options = null,
                               premium = null,
                               region = null,
                               showInfo = true,
                               infoText = '',
                               destinationsValue = null,
                               schemeId,
                               quoteReference = '',
                             }: IPriceDisplay) => {

  const [priceChange, setPriceChange] = useState(false);
  const InfoDisplay = priceChange ? <span> Your price has been recalculated for the options you've selected</span> :
    <div><span style={{ fontWeight: '700' }}>To calculate your price, we've made assumptions about you having no medical conditions and the cover you need. </span>
      You can change the details of your cover below and add medical conditions for you and any additional travellers on
      the next page.</div>

  useEffect(() => {
    if (options) {
      if (options.winter_sports || options.cruise_cover || options.gadget_cover || options.excess_waiver || options.golf_cover) {
        setPriceChange(true);
      }
    }
  }, [options]);

  return (
    <div className={'page-header-container'}>
      {leadTraveller && <div className={'greeting'}>Hi {get(leadTraveller, 'firstName')}!</div>}
      <div className={'title-section'}>
        <div>{title}</div>
        <div>{tripType === 'annual' ? 'Multi-Trip' : 'Single-Trip'} Travel Insurance</div>
      </div>

      {!schemeId && <div className={'price-container-empty'}/>}

      {schemeId && <div className={'price-container'}>
        <div className={'price-icon-container'}>
          <img src={require('../../../img/Plane.svg')} alt={'Admiral'}/>
        </div>
        <div className={'price-display-value'}>
          {!premium && (
            <Loading/>
          )}
          {premium && (
            <FormattedNumber
              value={premium.gross}
              style="currency"
              currency={premium.currency}
            />
          )}
          {tripType === 'annual' && (
            <span className={'price-affix'}>year</span>
          )}
          <div className={'price-info'}>figures include all applicable taxes</div>
        </div>
      </div>}
      {showInfo && premium && (
        <div className={'price-info-container'}>
          <div><FaInfoCircle className="info-btn info-icon"/></div>
          <div className={'info'}>{infoText ? infoText : InfoDisplay}</div>
        </div>
      )}
      {quoteReference && (
        <div className={'quote-reference'}>Quote Reference: {quoteReference}</div>
      )}
    </div>
  )
}
